<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Activity </strong>
                </v-toolbar-title>
            </v-toolbar>

            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" item-value="id"
                        :items="ay_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete color="#0F2027" dense rounded required v-model="activity_category" item-value="id"
                        :items="activity_category_list_with_all" item-text="name" label="Select Category" outlined
                        persistent-hint hint="Please select category" />
                </v-col>
            </v-row>

            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="4" md="4" class="text-center">
                    <v-btn class="mt-6 button" @click="getActivity()"> Fetch </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="activity_category_list_with_all" justify="start" dense class="activity-card-row">
                <v-col cols="12" sm="6" md="4" lg="3" class="d-flex justify-center"
                    v-for="(item, index) in activity_data_list_upcoming" :key="index">
                    <v-card class="activity-card activity-card-upcoming" elevation="6">
                        <div class="activity-card-header-upcoming">
                            <div class="activity-icon">
                                <v-icon>mdi-calendar-star</v-icon>
                            </div>

                            <div class="activity-title">{{ item.title || item.activity || '-' }}</div>
                        </div>
                        <div class="activity-detail">
                            <v-icon> mdi-calendar-month-outline </v-icon>

                            <span>
                                {{ item.start_date || item.start_date_edit || '-' }}

                                <span class="date-separator"> -- </span>

                                {{ item.end_date || item.end_date_edit || '-' }}
                            </span>
                        </div>

                        <!-- HOURS -->
                        <div class="activity-info-row">
                            <div class="activity-detail">
                                <v-icon>mdi-clock-outline</v-icon>
                                <span> <b>Duration:</b> {{ item.total_hours || 0 }} Hours </span>
                            </div>

                            <div class="activity-detail">
                                <v-icon>mdi-account-box</v-icon>
                                <span> <b>Seats:</b> {{ item.max_participants || 0 }} </span>
                            </div>
                        </div>

                        <!-- FEES -->
                        <div class="activity-info-row">
                            <div class="activity-detail">
                                <v-icon>mdi-receipt-text-outline</v-icon>
                                <span>
                                    <b>Fees:</b>
                                    <span v-if="Number(item.total_fees_amount || item.fees_amount || 0) === 0">
                                        Free
                                    </span>
                                    <span v-else> Rs. {{ item.total_fees_amount || item.fees_amount }} </span>
                                </span>
                            </div>

                            <div class="activity-detail">
                                <v-icon>mdi-view-grid-outline</v-icon>
                                <span> <b>Category:</b> {{ item.category || '-' }} </span>
                            </div>
                        </div>

                        <!-- STATUS -->
                        <div class="activity-detail">
                            <v-icon> mdi-chart-line </v-icon>

                            <span>
                                Status :
                                <strong> {{ getActivityStatus(item) }} </strong>
                            </span>
                        </div>

                        <div class="activity-buttons">
                            <v-btn small dark class="view-button" @click="viewDetails(item)"> View Details </v-btn>

                            <v-btn v-if="item.allowregistration && item.isactive && !isRegistrationOver(item)" small
                                color="primary" dark class="register-button" @click="openRegistrationDialog(item)">
                                Register
                            </v-btn>
                        </div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3" class="d-flex justify-center"
                    v-for="(item, index) in activity_data_list_today" :key="index">
                    <v-card class="activity-card activity-card-today" elevation="6">
                        <div class="activity-card-header-today">
                            <div class="activity-icon">
                                <v-icon>mdi-calendar-star</v-icon>
                            </div>

                            <div class="activity-title">{{ item.title || item.activity || '-' }}</div>
                        </div>

                        <div class="activity-detail">
                            <v-icon> mdi-calendar-month-outline </v-icon>

                            <span>
                                {{ item.start_date || item.start_date_edit || '-' }}

                                <span class="date-separator"> -- </span>

                                {{ item.end_date || item.end_date_edit || '-' }}
                            </span>
                        </div>
                        <div class="activity-info-row">
                            <div class="activity-detail">
                                <v-icon>mdi-clock-outline</v-icon>
                                <span> <b>Duration:</b> {{ item.total_hours || 0 }} Hours </span>
                            </div>

                            <div class="activity-detail">
                                <v-icon>mdi-account-box</v-icon>
                                <span> <b>Seats:</b> {{ item.max_participants || 0 }} </span>
                            </div>
                        </div>

                        <!-- FEES -->
                        <div class="activity-info-row">
                            <div class="activity-detail">
                                <v-icon>mdi-receipt-text-outline</v-icon>
                                <span>
                                    <b>Fees:</b>
                                    <span v-if="Number(item.total_fees_amount || item.fees_amount || 0) === 0">
                                        Free
                                    </span>
                                    <span v-else> Rs. {{ item.total_fees_amount || item.fees_amount }} </span>
                                </span>
                            </div>

                            <div class="activity-detail">
                                <v-icon>mdi-view-grid-outline</v-icon>
                                <span> <b>Category:</b> {{ item.category || '-' }} </span>
                            </div>
                        </div>

                        <div class="activity-detail">
                            <v-icon> mdi-chart-line </v-icon>

                            <span>
                                Status :
                                <strong> {{ getActivityStatus(item) }} </strong>
                            </span>
                        </div>

                        <div class="activity-buttons">
                            <v-btn small dark class="view-button" @click="viewDetails(item)"> View Details </v-btn>

                            <v-btn v-if="item.allowregistration && item.isactive" small color="primary" dark
                                class="register-button" @click="openRegistrationDialog(item)">
                                Register
                            </v-btn>
                        </div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3" class="d-flex justify-center"
                    v-for="(item, index) in activity_data_list_completed" :key="index">
                    <v-card class="activity-card activity-card-completed" elevation="6">
                        <!-- CARD HEADER -->
                        <div class="activity-card-header-completed">
                            <div class="activity-icon">
                                <v-icon>mdi-calendar-star</v-icon>
                            </div>

                            <div class="activity-title">{{ item.title || item.activity || '-' }}</div>
                        </div>

                        <div class="activity-detail">
                            <v-icon> mdi-calendar-month-outline </v-icon>

                            <span>
                                {{ item.start_date || item.start_date_edit || '-' }}

                                <span class="date-separator"> -- </span>

                                {{ item.end_date || item.end_date_edit || '-' }}
                            </span>
                        </div>

                        <div class="activity-info-row">
                            <div class="activity-detail">
                                <v-icon>mdi-clock-outline</v-icon>
                                <span> <b>Duration:</b> {{ item.total_hours || 0 }} Hours </span>
                            </div>

                            <div class="activity-detail">
                                <v-icon>mdi-account-box</v-icon>
                                <span> <b>Seats:</b> {{ item.max_participants || 0 }} </span>
                            </div>
                        </div>

                        <!-- FEES -->
                        <div class="activity-info-row">
                            <div class="activity-detail">
                                <v-icon>mdi-receipt-text-outline</v-icon>
                                <span>
                                    <b>Fees:</b>
                                    <span v-if="Number(item.total_fees_amount || item.fees_amount || 0) === 0">
                                        Free
                                    </span>
                                    <span v-else> Rs. {{ item.total_fees_amount || item.fees_amount }} </span>
                                </span>
                            </div>

                            <div class="activity-detail">
                                <v-icon>mdi-view-grid-outline</v-icon>
                                <span> <b>Category:</b> {{ item.category || '-' }} </span>
                            </div>
                        </div>

                        <div class="activity-detail">
                            <v-icon> mdi-chart-line </v-icon>

                            <span>
                                Status :
                                <strong> Closed </strong>
                            </span>
                        </div>

                        <div class="activity-buttons">
                            <v-btn small dark class="view-button" @click="viewDetails(item)"> View Details </v-btn>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="activityDetailsDialog" max-width="1100px" width="1100px" scrollable persistent>
            <v-card class="activity-details-dialog-card">
                <v-toolbar flat dense class="dialog-toolbar">
                    <v-toolbar-title>
                        <strong>Activity Details</strong>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="closeActivityDetailsDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="activity-details-dialog-content">
                    <!-- YOUR COMPLETE ACTIVITY DETAILS CONTENT STARTS HERE -->

                    <div class="table-wrapper activity-details-table-wrapper">
                        <table class="bordered-table transaction-table activity-details-table">
                            <thead>
                                <tr>
                                    <th>Activity Title</th>
                                    <th>Category</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Academic Year</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>{{ selectedActivity.title || '-' }}</td>

                                    <td>{{ selectedActivity.category || '-' }}</td>

                                    <td>
                                        {{ selectedActivity.start_date_edit || selectedActivity.start_date || '-' }}
                                    </td>

                                    <td>{{ selectedActivity.end_date_edit || selectedActivity.end_date || '-' }}</td>

                                    <td>{{ selectedActivity.ay || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- BUTTONS -->
                    <div class="button-wrapper">
                        <v-btn v-if="!selectedParticipant || !selectedParticipant.id" small color="error"
                            class="action-btn" @click="openRegistrationDialog(selectedActivity)">
                            Register
                        </v-btn>

                        <!-- <v-btn small color="primary" class="action-btn" @click="printActivityPass(selectedActivity)">
                            Print Activity Pass
                        </v-btn>

                        <v-btn small color="black" dark class="action-btn" @click="markAttendance(selectedActivity)">
                            Mark Attendance
                        </v-btn> -->

                        <v-btn v-if="
                            isActivityEnded(selectedActivity) &&
                            !feedbackGivenActivities[selectedActivity.id]
                        " small color="success" class="action-btn" @click="openFeedbackDialog(selectedActivity)">
                            Give Feedback
                        </v-btn>
                    </div>

                    <!-- PARTICIPANT DETAILS -->
                    <div class="participant-table-scroll" v-if="selectedParticipant && selectedParticipant.id">
                        <table class="participant-table">
                            <tbody>
                                <!-- LABEL ROW 1 -->
                                <tr>
                                    <th>Name</th>
                                    <th>Employee Code / PRN</th>
                                    <th>Affiliation Type</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Organization Name</th>
                                </tr>

                                <!-- VALUE ROW 1 -->
                                <tr>
                                    <td>{{ selectedParticipant.name || '-' }}</td>

                                    <td>
                                        {{ selectedParticipant.learner_id &&
                                            selectedParticipant.learner_id.registration_number ?
                                            selectedParticipant.learner_id.registration_number : '-' }}
                                    </td>

                                    <td>{{ selectedParticipant.affiliation_type || '-' }}</td>

                                    <td>{{ selectedParticipant.email || '-' }}</td>

                                    <td>{{ selectedParticipant.mobile || '-' }}</td>

                                    <td>{{ selectedParticipant.organization_name || '-' }}</td>
                                </tr>

                                <!-- LABEL ROW 2 -->
                                <tr>
                                    <th>Participant Type</th>
                                    <th>Registration Date</th>
                                    <th>Fee Amount</th>
                                    <th>Payment Status</th>
                                    <th>Payment Mode</th>
                                    <th>Receipt</th>
                                </tr>

                                <!-- VALUE ROW 2 -->
                                <tr>
                                    <td>{{ selectedParticipant.participant_type || '-' }}</td>

                                    <td>{{ selectedParticipant.registration_date || '-' }}</td>

                                    <td>
                                        {{ selectedParticipant.fees_amount != null ? selectedParticipant.fees_amount :
                                            '-' }}
                                    </td>

                                    <td>{{ selectedParticipant.is_payment_done ? 'Paid' : 'Not Paid' }}</td>

                                    <td>{{ selectedParticipant.paymentmode || '-' }}</td>

                                    <td>{{ selectedParticipant.receipt_no || '-' }}</td>
                                </tr>

                                <!-- LABEL ROW 3 -->
                                <tr>
                                    <th>Is Approved?</th>
                                    <th>Approval Date</th>
                                    <th>Remark</th>
                                    <th>Attendance</th>
                                    <th>Feedback</th>
                                    <th>Certificate</th>
                                </tr>

                                <!-- VALUE ROW 3 -->
                                <tr>
                                    <td>{{ selectedParticipant.is_approved ? 'Yes' : 'No' }}</td>

                                    <td>{{ selectedParticipant.approval_date || '-' }}</td>

                                    <td>{{ selectedParticipant.remark || '-' }}</td>

                                    <td>
                                        <v-icon class="view-icon"> mdi-eye </v-icon>
                                    </td>

                                    <td>
                                        <v-tooltip bottom v-if="selectedParticipant.has_feedback">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                                    @click="viewSubmittedFeedback(selectedParticipant)">
                                                    <v-icon class="view-icon">mdi-eye</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>View Feedback</span>
                                        </v-tooltip>

                                        <v-tooltip bottom v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small disabled v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1">mdi-eye-off</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>No Feedback Given</span>
                                        </v-tooltip>
                                    </td>
                                

                                    <td>
                                        <v-tooltip bottom v-if="selectedParticipant.has_certificate">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                                    @click="viewCertificate(selectedParticipant.certificate_url)">
                                                    <v-icon class="view-icon">mdi-eye</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>View Certificate</span>
                                        </v-tooltip>

                                        <v-tooltip bottom v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small disabled v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1">mdi-eye-off</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Certificate Not Generated</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- ACTIVITY SCHEDULE -->
                    <div class="activity-schedule-section">
                        <h3 class="section-title">Activity Schedule</h3>

                        <div class="schedule-table-scroll">
                            <table class="schedule-table">
                                <thead>
                                    <tr>
                                        <th>Session No</th>
                                        <th>Date</th>
                                        <th>Duration(Hrs)</th>
                                        <th>Resource Person</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(session, index) in (selectedActivity.activity_session_data_list || [])"
                                        :key="session.id || index">
                                        <!-- SESSION NO -->
                                        <td>{{ session.session_no || index + 1 }}</td>

                                        <!-- DATE -->
                                        <td>{{ session.session_start_date || '-' }}</td>

                                        <!-- DURATION -->
                                        <td>{{ session.duration_in_hours || '-' }}</td>

                                        <!-- RESOURCE PERSON -->
                                        <td>{{ session.resourceperson || '-' }}</td>

                                        <!-- DESCRIPTION -->
                                        <td>{{ session.description || '-' }}</td>
                                    </tr>

                                    <tr v-if="
                                        !selectedActivity.activity_session_data_list ||
                                        selectedActivity.activity_session_data_list.length === 0
                                    ">
                                        <td colspan="5" class="no-data">No schedule available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- YOUR ACTIVITY DETAILS CONTENT ENDS HERE -->
                </v-card-text>

                <!-- FIXED BOTTOM BUTTON -->
                <v-divider></v-divider>

                <v-card-actions class="dialog-actions">
                    <v-spacer></v-spacer>

                    <v-btn color="primary" @click="closeActivityDetailsDialog"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="feedbackDialog" max-width="1000px" scrollable>
            <v-card class="feedback-dialog-card">
                <!-- HEADER -->
                <v-toolbar flat dense class="dialog-toolbar">
                    <v-toolbar-title>
                        <strong>Give Feedback</strong>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="feedbackDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <!-- CONTENT -->
                <v-card-text class="feedback-dialog-content">
                    <!-- ACTIVITY DETAILS -->
                    <div class="feedback-table-wrapper">
                        <table class="feedback-table">
                            <thead>
                                <tr>
                                    <th>Activity Title</th>
                                    <th>Category</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Academic Year</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>{{ feedbackDetails.title || '-' }}</td>

                                    <td>{{ feedbackDetails.category || '-' }}</td>

                                    <td>{{ feedbackDetails.start_date_edit || feedbackDetails.start_date || '-' }}</td>

                                    <td>{{ feedbackDetails.end_date_edit || feedbackDetails.end_date || '-' }}</td>

                                    <td>{{ feedbackDetails.ay || '-' }}</td>
                                </tr>

                                <!-- PARTICIPANT HEADER -->
                                <tr class="participant-header">
                                    <th>Participant Name</th>

                                    <th>Employee Code / PRN</th>

                                    <th>Affiliation Type</th>

                                    <th>Participant Type</th>

                                    <th>Feedback Date</th>
                                </tr>

                                <!-- PARTICIPANT DATA -->
                                <tr>
                                    <td>{{ feedbackParticipant.name || '-' }}</td>

                                    <td>
                                        <!-- {{
                                    feedbackParticipant.employee_code ||
                                    feedbackParticipant.prn ||
                                    '-'
                                }} -->
                                        {{ feedbackParticipant.learner_id &&
                                            feedbackParticipant.learner_id.registration_number ?
                                            feedbackParticipant.learner_id.registration_number : '-' }}
                                    </td>

                                    <td>{{ feedbackParticipant.affiliation_type || '-' }}</td>

                                    <td>{{ feedbackParticipant.participant_type || '-' }}</td>

                                    <td>{{ feedbackDate || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- RATING -->
                    <div class="rating-section">
                        <div class="field-title">Rating</div>

                        <v-rating v-model="feedbackRating" :length="feedbackDetails.max_feedback_rating || 5" hover
                            dense color="amber" background-color="grey lighten-2">
                        </v-rating>
                    </div>

                    <!-- COMMENT -->
                    <div class="comment-section">
                        <div class="field-title">Comment</div>

                        <v-textarea v-model="feedbackComments" outlined rows="4" hide-details class="comment-box">
                        </v-textarea>
                    </div>

                    <!-- SAVE -->
                    <div class="save-section">
                        <v-btn small color="primary" class="save-button" @click="saveFeedback"> Save </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- VIEW FEEDBACK DIALOG (READ ONLY) -->
        <v-dialog v-model="viewFeedbackDialog" max-width="600px" persistent>
            <v-card>
                <v-toolbar flat dense class="dialog-toolbar">
                    <v-toolbar-title>
                        <strong>Submitted Feedback</strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="viewFeedbackDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="pt-4">
                    <div class="mb-3">
                        <strong>Participant: </strong>
                        <span>{{ selectedParticipant.name || '-' }}</span>
                    </div>

                    <div class="mb-3" v-if="selectedParticipant.feedback_date">
                        <strong>Submitted On: </strong>
                        <span>{{ selectedParticipant.feedback_date }}</span>
                    </div>

                    <div class="mb-3">
                        <div class="font-weight-bold mb-1">Rating:</div>
                        <v-rating
                            v-model="viewingFeedbackData.rating"
                            :length="selectedActivity.max_feedback_rating || 5"
                            readonly
                            dense
                            color="amber"
                            background-color="grey lighten-2">
                        </v-rating>
                    </div>

                    <div class="mb-3">
                        <div class="font-weight-bold mb-1">Comments:</div>
                        <v-textarea
                            v-model="viewingFeedbackData.comments"
                            outlined
                            readonly
                            rows="3"
                            hide-details>
                        </v-textarea>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="viewFeedbackDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="newRegistartionDialog" hide-overlay persistent width="1100">
            <v-card>
                <v-card-title>Add / Update Registration</v-card-title>
                <v-card-text>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-autocomplete color="#0F2027" dense required v-model="affiliation_type"
                                    item-value="id" :items="affiliation_type_data_list" item-text="name"
                                    label="Select Affiliation Type" />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field v-model="registration_name" type="text" label="Name"
                                    required></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field v-model="registration_mobile_number" type="number" label="Mobile"
                                    required></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field v-model="registration_email" type="text" label="Email"
                                    required></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field v-model="registration_org_name" type="text" label="Organization Name"
                                    required></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field readonly v-model="registration_fee_amount" type="number"
                                    label="Fee Amount" required></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <center>
                    <v-btn color="blue darken-1" text @click="close_reg_dialog()">Cancel</v-btn>
                    <form v-if="activity_id" :action="paytmInitiateUrl" @submit="payment" name="paytmform" method="POST">
                        <input type="hidden" :value="orgid" name="orgid" />
                        <input type="hidden" :value="tenantid" name="tenantid" />
                        <input type="hidden" :value="uid" name="uid" />
                        <input type="hidden" :value="registration_fee_amount" name="amount" />
                        <input type="hidden" :value="registration_name" name="registration_name" />
                        <input type="hidden" :value="registration_mobile_number" name="registration_mobile_number" />
                        <input type="hidden" :value="registration_org_name" name="registration_org_name" />
                        <input type="hidden" :value="registration_email" name="registration_email" />
                        <input type="hidden" :value="affiliation_type" name="affiliation_type" />
                        <input type="hidden" :value="activity_id.hash_val" name="hash_val" />
                        <input type="hidden" :value="sel_ay_data" name="academicyear" />
                        <input type="hidden" :value="activity_id.id" name="activity_id" />
                        <input type="hidden" value="ACTIVITY-REGISTRATION" name="purpose" />
                        <v-btn color="blue darken-1" text :loading="pg_loader" type="submit" v-if="registration_fee_amount != 0">
                            Pay Online (Paytm)
                        </v-btn>
                    </form>

                    <!-- <v-btn color="blue darken-1" text @click="addNewRegistration()">Save</v-btn> -->
                </center>
            </v-card>
        </v-dialog>
        <v-form v-if="pg_js_url" :action="pg_js_url" method="POST" name="paytmform">

        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            activity_category_list: [],
            activity_category_list_with_all: [],
            ay_list: [],
            activity_data_list_today: [],
            activity_data_list_upcoming: [],
            activity_data_list_completed: [],
            activityDetailsDialog: false,
            selectedActivity: {},
            selectedParticipant: {},
            feedbackDialog: false,
            feedbackDetails: {},
            feedbackGivenActivities: {},
            feedbackParticipant: {},
            feedbackRating: 0,
            feedbackComments: "",
            feedbackDate: "",
            newRegistartionDialog: false,
            feedbackSnackbar: false,
            feedbackSnackbarMsg: "",
            registraion_inst: null,
            registration_learner: null,
            participant_type_data_list: [],
            affiliation_type_data_list: [],
            payment_mode_list: [],
            registration_parent: null,
            registration_name: null,
            registration_mobile_number: null,
            registration_org_name: null,
            registration_email: null,
            registration_fee_amount: null,
            payment_mode: null,
            affiliation_type: null,
            edited_item: 0,
            feedbackColor: "",
            paytmInitiateUrl: null,
            tenantid: null,
            orgid: null,
            uid: null,
            pg_js_url: null,
            activity_id: null,
            sel_ay_data: null,
            activity_category: null,
            viewFeedbackDialog: false,
            viewingFeedbackData: {
                rating: 0,
                comments: ""
            },
        };
    },
    created() {
        this.paytmInitiateUrl = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytmActivityRegistartion";
    },

    computed: {
        filteredActivities() {
            var activities = [];
            activities = activities.concat(this.activity_data_list_today || []);
            activities = activities.concat(this.activity_data_list_upcoming || []);
            activities = activities.concat(this.activity_data_list_completed || []);

            // If "All" is selected, show all activities
            if (this.activity_category == 0 || this.activity_category == "0") {
                return activities;
            }

            // Get selected category
            var selectedCategory = this.activity_category_list_with_all.find(function (category) {
                return category.category_id == this.activity_category;
            });

            if (!selectedCategory) {
                return [];
            }

            var selectedCategoryName = (selectedCategory.name || "").toString().trim().toLowerCase();

            return activities.filter(function (item) {
                var activityCategory = (item.category || "").toString().trim().toLowerCase();

                return activityCategory == selectedCategoryName;
            });
        },
    },

    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        openRegistrationDialog(item) {
            this.registration_fee_amount = item.total_fees_amount
            this.activity_id = item
            this.newRegistartionDialog = true;
        },
        onload() {
            this.overlay = true;

            axios
                .post("/Activity/getInitaialData")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.activity_category_list = res.data.activity_category_list;
                        this.affiliation_type_data_list = res.data.affiliation_type_data_list
                        this.activity_category_list_with_all = res.data.activity_category_list_with_all;
                        this.ay_list = res.data.ay_list;

                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");

                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        close_reg_dialog() {
            this.reg_participant_type = null;
            this.registration_name = null;
            this.registration_mobile_number = null;
            this.registration_org_name = null;
            this.registration_email = null;
            this.registration_fee_amount = null;
            this.affiliation_type = null;
            this.newRegistartionDialog = false;
        },
        payment() {
                var formData = new FormData(paytmform);
                this.pg_loader = false;
            },
    
        getActivity() {
            const data = {
                ay_id: this.sel_ay_data,
                id: this.activity_category,
            };

            axios
                .post("/Activity/getActivityList", data)
                .then((res) => {
                    this.activity_data_list_today = res.data.activity_data_list_today;

                    this.activity_data_list_upcoming = res.data.activity_data_list_upcoming;

                    this.activity_data_list_completed = res.data.activity_data_list_completed;
                    this.tenantid = res.data.tenantid;
                    this.orgid = res.data.orgid;
                    this.uid = res.data.uid;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => { });
        },

        viewDetails(item) {

            this.selectedActivity = item;
             this.selectedActivity.isAlreadyRegistered = this.isStudentAlreadyRegistered(item);
            this.selectedParticipant = {};
            this.activityDetailsDialog = true;

            axios
                .post("/Activity/getRegistrationDetails", {
                    activity_id: item.id,
                })
                .then((res) => {

                    if (
                        res.data &&
                        res.data.activity_registartion_details &&
                        res.data.activity_registartion_details.length > 0
                    ) {
                        // Since backend already returns logged-in user's registration
                        this.selectedParticipant = res.data.activity_registartion_details[0];

                        console.log("Selected Participant:", this.selectedParticipant);
                    } else {
                        this.selectedParticipant = {};
                    }
                })
                .catch((error) => {
                    console.log("Registration API Error:", error);
                    this.selectedParticipant = {};
                });
        },

        viewCertificate(url) {
            if (url) {
                window.open(url, "_blank");
            } else {
                this.showSnackbar("#b71c1c", "Certificate is not available.");
            }
        },
        openFeedbackDialog(item) {
            console.log("Feedback Activity:", item);

            this.feedbackDetails = item;

            // Use the participant already fetched by getRegistrationDetails
            this.feedbackParticipant = this.selectedParticipant;

            console.log("Feedback Participant:", this.feedbackParticipant);

            console.log("Registration ID:", this.feedbackParticipant.id);

            this.feedbackRating = 0;
            this.feedbackComments = "";

            var today = new Date();
            var day = String(today.getDate()).padStart(2, "0");
            var month = String(today.getMonth() + 1).padStart(2, "0");
            var year = today.getFullYear();

            this.feedbackDate = day + "/" + month + "/" + year;

            this.feedbackDialog = true;
        },

        saveFeedback() {
            let data = {
                activity_id: this.feedbackDetails.id,
                registration_id: this.feedbackParticipant.id,
                rating: this.feedbackRating,
                comments: this.feedbackComments,
            };

            console.log("Feedback data:", data);

            axios
                .post("/Activity/saveActivityFeedback", data)
                .then((res) => {
                    console.log("Save Feedback Response:", res.data);

                    if (res.data.status && res.data.status.code == "SUCCESS") {

                        this.showSnackbar("#4caf50", "Feedback saved successfully...");

                        // Mark feedback as given for this activity
                        this.$set(
                            this.feedbackGivenActivities,
                            this.feedbackDetails.id,
                            true
                        );

                        this.feedbackDialog = false;
                    }
                    else if (res.data.status && res.data.status.code == "NA") {
                        this.showSnackbar("#b71c1c", "Feedback already given!!!");
                    } else {
                        this.showSnackbar("#b71c1c", "Feedback could not be saved...");
                    }
                })
                .catch((error) => {
                    console.log("Feedback Save Error:", error);

                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },



        closeActivityDetailsDialog() {
            this.activityDetailsDialog = false;
            this.close_reg_dialog();
        },

        isRegistrationOver(item) {
            if (!item.registration_end_date_edit) {
                return false;
            }

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            var registrationEndDate = new Date(item.registration_end_date_edit);

            registrationEndDate.setHours(0, 0, 0, 0);

            return registrationEndDate < today;
        },
        viewSubmittedFeedback(participant) {
            this.viewingFeedbackData = {
                rating: participant.feedback_rating || 0,
                comments: participant.feedback_comments || "No comments provided."
            };
            this.viewFeedbackDialog = true;
        },

        isActivityEnded(item) {
            if (!item || (!item.end_date && !item.end_date_edit)) {
                return false;
            }

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            var activityEndDate = new Date(
                item.end_date_edit || item.end_date
            );

            activityEndDate.setHours(0, 0, 0, 0);

            // Feedback is available on the end date and after
            return activityEndDate <= today;
        },

        isStudentAlreadyRegistered(activity) {
            if (!activity || !activity.activity_registartion_list) {
                return false;
            }

            const registrationNo = localStorage.getItem('EPS-regno');

            if (!registrationNo) {
                return false;
            }

            return activity.activity_registartion_list.some(
                registration =>
                    registration.registration_number === registrationNo
            );
        },




        getActivityStatus(item) {
            if (this.isRegistrationOver(item)) {
                return "Registration Closed";
            }

            if (item.isactive) {
                return "Open";
            }

            return "Closed";
        },
    },

    mounted() {
        this.onload();
    },
};
</script>

<style scoped>
.activity-card-row {
    padding: 20px 25px;
    row-gap: 25px;
    column-gap: 0;
}

.activity-card {
    width: 100%;
    max-width: 350px;
    height: 270px;

    background: #ffffff !important;

    border: 1px solid #d6dce5 !important;
    border-radius: 6px !important;

    padding: 15px 17px;

    display: flex;
    flex-direction: column;

    box-sizing: border-box;

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;

    overflow: hidden;

    transition: all 0.2s ease;
}

.activity-card:hover {
    transform: translateY(-2px);

    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.16) !important;
}

.activity-card-upcoming {
    background: #ffffff !important;

    border-top: 4px solid #49619f !important;
}


.activity-card-today {
    background: #ffffff !important;

    border-top: 4px solid #43a047 !important;
}


.activity-card-completed {
    background: #ffffff !important;
    border-top: 4px solid #e57373 !important;
}


.activity-card-header-completed {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 9px;
    border-bottom: 2px solid #e91e63;
    min-height: 42px;
}

.activity-card-header-today {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 9px;
    border-bottom: 2px solid #43a047;
    min-height: 42px;
}

.activity-card-header-upcoming {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 9px;
    border-bottom: 2px solid #49619f;
    min-height: 42px;
}


.activity-icon {
    min-width: 32px;

    width: 32px;

    margin-right: 8px;

    display: flex;

    align-items: center;

    justify-content: center;
}


.activity-icon .v-icon {
    font-size: 22px !important;

    color: #49619f !important;
}


.activity-title {
    font-size: 16px;

    font-weight: 700;

    line-height: 20px;

    color: #263b63;

    overflow: hidden;

    text-overflow: ellipsis;

    display: -webkit-box;

    -webkit-line-clamp: 2;

    -webkit-box-orient: vertical;
}

.activity-detail {
    display: flex;

    align-items: center;

    min-height: 29px;

    font-size: 14px;

    line-height: 18px;

    margin-top: 3px;

    color: #444;
}


.activity-detail .v-icon {
    margin-right: 7px;

    font-size: 17px !important;

    color: #607d9f !important;
}


.activity-detail b {
    color: #444;

    font-weight: 600;
}


.activity-detail strong {
    color: #263b63;

    font-weight: 700;
}

.date-separator {
    margin: 0 5px;

    color: #999;
}

.activity-info-row {
    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 8px;

    width: 100%;

    margin-top: 2px;
}


.activity-info-row .activity-detail {
    width: 50%;
    min-width: 0;
    margin-top: 0;
    overflow: visible;
}

.activity-info-row .activity-detail span {
    overflow: visible;
    text-overflow: unset;
    white-space: normal;
}

.activity-card>.activity-detail {
    margin-top: 5px;
}

.activity-buttons {
    display: flex;

    justify-content: space-between;

    align-items: center;

    margin-top: auto;

    padding-top: 12px;
}

.view-button {
    background: #666 !important;
    text-transform: none !important;

    height: 28px !important;
    min-height: 28px !important;

    padding: 0 12px !important;

    font-size: 11px !important;

    min-width: 85px !important;

    border-radius: 4px !important;
}


.register-button {
    text-transform: none !important;

    height: 28px !important;
    min-height: 28px !important;

    padding: 0 12px !important;

    font-size: 11px !important;

    min-width: 70px !important;

    border-radius: 4px !important;
}
.dialog-toolbar {
    background: #f5f5f5 !important;
    flex: 0 0 auto;
}
.activity-details-dialog-card {
    width: 100%;
    max-height: 90vh !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    background: #ffffff !important;
}
.activity-details-dialog-content {
    flex: 1 1 auto !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    max-height: calc(90vh - 110px) !important;
    padding: 20px !important;
    background: #ffffff !important;
}

.table-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 28px;
    overflow-x: auto;
}

.bordered-table {
    border-collapse: collapse;
    margin-top: 10px;
    text-align: center;
    color: #000;
}

.transaction-table {
    width: 85%;
    min-width: 700px;
}
.activity-details-table-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 25px;
    overflow-x: auto;
}

.activity-details-table {
    width: 75% !important;
    min-width: 700px;
    margin: 0 auto !important;
    border-collapse: collapse;
    table-layout: fixed;
}

.activity-details-table th,
.activity-details-table td {
    border: 2px solid #1e3a8a !important;
    padding: 10px 8px;
    height: 45px;
    font-size: 14px;
    text-align: center !important;
    vertical-align: middle !important;
}

.activity-details-table th {
    font-weight: bold;
    white-space: normal !important;
    line-height: 20px;
}

.activity-details-table td {
    word-break: break-word;
}

.activity-details-table th:nth-child(1),
.activity-details-table td:nth-child(1) {
    width: 24%;
}

.activity-details-table th:nth-child(2),
.activity-details-table td:nth-child(2) {
    width: 17%;
}

.activity-details-table th:nth-child(3),
.activity-details-table td:nth-child(3) {
    width: 19%;
}

.activity-details-table th:nth-child(4),
.activity-details-table td:nth-child(4) {
    width: 19%;
}

.activity-details-table th:nth-child(5),
.activity-details-table td:nth-child(5) {
    width: 21%;
}

.bordered-table th,
.bordered-table td {
    border: 2px solid #1e3a8a;
    padding: 10px 14px;
    font-size: 15px;
    height: 30px;
}

.button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 25px;
    margin-top: 30px;
    margin-bottom: 30px;
    flex-wrap: wrap;
}

.action-btn {
    min-width: 110px;
    text-transform: none;
}

.participant-table-scroll {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 30px;
    overflow-x: hidden;
}

.participant-table {
    width: 90%;
    margin: 0 auto;
    border-collapse: collapse;
    table-layout: fixed;
    background: #ffffff;
}
.participant-table th,
.participant-table td {
    border: 2px solid #1e3a8a !important;
    padding: 10px 8px;
    height: 45px;
    font-size: 14px;
    text-align: center !important;
    vertical-align: middle !important;
    color: #000 !important;
}
.participant-table th {
    font-weight: bold;
    white-space: normal;
    line-height: 20px;
}

.participant-table td {
    word-break: break-word;
}

.participant-table th:nth-child(1),
.participant-table td:nth-child(1) {
    width: 16.66%;
}

.participant-table th:nth-child(2),
.participant-table td:nth-child(2) {
    width: 16.66%;
}

.participant-table th:nth-child(3),
.participant-table td:nth-child(3) {
    width: 16.66%;
}

.participant-table th:nth-child(4),
.participant-table td:nth-child(4) {
    width: 16.66%;
}

.participant-table th:nth-child(5),
.participant-table td:nth-child(5) {
    width: 16.66%;
}

.participant-table th:nth-child(6),
.participant-table td:nth-child(6) {
    width: 16.66%;
}

.view-icon {
    cursor: pointer;
}

.schedule-table {
    width: 75%;
    min-width: 700px;
    margin: 0 auto;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 14px;
    background: #ffffff;
}

.schedule-table th {
    text-align: center !important;
    vertical-align: middle !important;
    font-weight: bold;
    padding: 10px 8px;
    height: 45px;
    white-space: normal !important;
    border: 2px solid #1e3a8a !important;
    color: #000 !important;
    line-height: 20px;
}
.schedule-table td {
    text-align: center !important;
    vertical-align: middle !important;
    padding: 10px 8px;
    height: 45px;
    border: 2px solid #1e3a8a !important;
    word-break: break-word;
    color: #000 !important;
}

.schedule-table th:nth-child(1),
.schedule-table td:nth-child(1) {
    width: 12%;
    text-align: center !important;
    vertical-align: middle !important;
}
.schedule-table th:nth-child(2),
.schedule-table td:nth-child(2) {
    width: 18%;
}
.schedule-table th:nth-child(3),
.schedule-table td:nth-child(3) {
    width: 18%;
}
.schedule-table th:nth-child(4),
.schedule-table td:nth-child(4) {
    width: 25%;
}
.schedule-table th:nth-child(5),
.schedule-table td:nth-child(5) {
    width: 27%;
}
.feedback-dialog-card {
    width: 100%;
    max-height: 90vh !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #ffffff !important;
}

.feedback-dialog-content {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(90vh - 70px);
    padding: 25px !important;
}

.section-title {
    text-align: center;
    font-size: 20px;
    color: #000;
    margin-bottom: 10px;
}

/* FEEDBACK TABLE */

.feedback-table-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    overflow-x: auto;
}

.feedback-table {
    width: 90%;
    min-width: 750px;
    margin: 0 auto;
    border-collapse: collapse;
    table-layout: fixed;
    text-align: center;
    color: #000;
}

.feedback-table th,
.feedback-table td {
    border: 2px solid #1e3a8a;
    padding: 10px 14px;
    height: 45px;
    font-size: 15px;
    text-align: center;
    vertical-align: middle;
}

.feedback-table th {
    font-weight: bold;
    white-space: normal !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    line-height: 20px;
}

.feedback-table th:nth-child(2) {
    width: 22% !important;
    white-space: normal !important;
    word-break: normal !important;
}

.feedback-table th:nth-child(1),
.feedback-table td:nth-child(1) {
    width: 22%;
}

.feedback-table th:nth-child(2),
.feedback-table td:nth-child(2) {
    width: 18%;
}

.feedback-table th:nth-child(3),
.feedback-table td:nth-child(3) {
    width: 18%;
}

.feedback-table th:nth-child(4),
.feedback-table td:nth-child(4) {
    width: 18%;
}

.feedback-table th:nth-child(5),
.feedback-table td:nth-child(5) {
    width: 24%;
}

.rating-section {
    text-align: center;
    margin-top: 35px;
}

.field-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
}

.comment-section {
    width: 600px;
    max-width: 90%;
    margin: 30px auto 0 auto;
}

.comment-box {
    width: 100%;
}

.comment-box *>>>* textarea {
    font-size: 18px !important;
    min-height: 150px !important;
    height: 150px !important;
}
.save-section {
    text-align: center;
    margin-top: 25px;
    margin-bottom: 15px;
}

.save-button {
    text-transform: none !important;
}
</style>
